export default "__VITE_ASSET__Bhv78LfG__"